import { render } from "./NewsDetail.vue?vue&type=template&id=0d7bef17&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"

import "./NewsDetail.vue?vue&type=style&index=0&id=0d7bef17&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7bef17"]])

export default __exports__